import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CategoriaPermissaoRoutingModule } from './categoria-permissao-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CategoriaPermissaoRoutingModule
  ]
})
export class CategoriaPermissaoModule { }
